import * as React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { fetchLocation, fetchUsers } from  './../redux/actions/locations'
import Page from './../components/shared/page'
import './../styles/admin/admin.css'
import timeago from 'timeago.js';
import strftime from 'strftime';
import arrow from './../images/left-arrow-circle.png'

class Location extends React.Component {

  componentDidMount() {
    this.props.fetchLocation(this.props.match.params.id)
    this.props.fetchUsers(this.props.match.params.id)
  }

  render () {
    const location_data = this.props.locations
    return (
      <Page history={this.props.history} >
        {location_data && location_data.location &&
          <div className='admin-outer-container'>
            <div className='admin-location-header'>
              <Link to='/admin/locations'>
                <div className='admin-back-button'>
                  <img src={arrow} alt='Back'/>
                </div>
              </Link>
              <h1>{location_data.location.name}</h1>
            </div>
            <div className='admin-inner-container'>
              <div>
                <h3>Bays</h3>
                <table className='recordings-table'>
                  <thead>
                    <tr>
                      <th>Bay</th>
                      <th>Last visit</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {location_data.location.bays.map((bay, index) => {
                      return(
                        <tr key={'bay' + index} className='recordings-row'>
                          <td className='admin-location-td'>{bay.number}</td>
                          <td className='admin-location-td'>{timeago().format(bay.last_visit_at)}</td>
                          <td className='admin-location-td'>{strftime('%B %d, %Y %I:%M %p', new Date(bay.last_visit_at))}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
              <div>
                <h3>Config JSON</h3>
                {location_data &&
                  <div>
                    <textarea value={JSON.stringify(location_data.location)} readOnly className='text-area'/>
                  </div>
                }
              </div>
              <div>
                <h3>Users</h3>
                <table className='recordings-table'>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Email</th>
                      <th>Last Login</th>
                    </tr>
                  </thead>
                  <tbody>
                {location_data.users.map((user,index) => {
                  return(
                    <tr key={'user' + index} className='recordings-row'>
                      <td className='admin-location-td'>{user.id}</td>
                      <td className='admin-location-td'>{user.email}</td>
                      <td className='admin-location-td'>{strftime('%B %d, %Y %I:%M %p', new Date(user.last_login))}</td>
                    </tr>
                  )
                })}
                </tbody>
              </table>
              </div>
            </div>
          </div>
        }

      </Page>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = dispatch => {
  return {
    fetchLocation: (id) => {
      return dispatch(fetchLocation(id));
    },
    fetchUsers: (id) => {
      return dispatch(fetchUsers(id))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Location)



// WEBPACK FOOTER //
// ./src/pages/location.js